import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { FluxOptionsService } from '../filter-options.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Kaza } from '@adeo/ngx-kozikaza-api';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsFilters } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-filters.icon';
import { kzIconsCross } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-cross.icon';

@Component({
  selector: 'app-flux-options-menu',
  templateUrl: './flux-options-menu.component.html',
  styleUrls: ['./flux-options-menu.component.scss']
})
export class FluxOptionsMenuComponent implements OnInit, OnDestroy {
  @Input() activeKaza: Kaza = null;
  @Output() switchChanged = new EventEmitter<string>();
  @Output() filtersChanged = new EventEmitter();
  @Input() switch = 'publications';

  filters = ['search', 'tags', 'type', 'types', 'builder', 'geoloc', 'countries', 'languages'];
  activeTab = 'filters-search';
  dialogSubscription: Subscription;

  constructor(
    public fluxOptionsService: FluxOptionsService,
    protected cdr: ChangeDetectorRef,
    protected readonly localizeRouterService: LocalizeRouterService,
    protected kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsFilters, kzIconsCross]);
  }

  ngOnInit() {
    this.fluxOptionsService.loadData();
  }

  ngOnDestroy(): void {
    if (this.dialogSubscription && !this.dialogSubscription.closed) {
      this.dialogSubscription.unsubscribe();
    }
  }

  openPopin() {
    this.dialogSubscription = this.fluxOptionsService.openPopin(this.activeKaza, this.activeTab, this.filters).afterClosed().subscribe(
      (result) => {
        if (result?.response) {
          this.applyFilters();
        }
      }
    );
  }

  changeSwitch() {
    this.switch = ((this.switch === 'publications') ? 'members' : 'publications');
    this.switchChanged.emit(this.switch);
    this.fluxOptionsService.cleanFilters();
    this.cdr.detectChanges();
    const translatedRoute = this.localizeRouterService.translateRoute(['kazacafe', 'explore']) as any[];
    this.fluxOptionsService.redirect(translatedRoute, this.switch);

  }

  removeFilter(filter: any) {
    this.fluxOptionsService.removeFilter(filter);
    this.applyFilters();
    this.cdr.detectChanges();
  }

  removeAllFilters() {
    this.fluxOptionsService.removeAllFilters();
    this.applyFilters();
    this.cdr.detectChanges();
  }

  applyFilters() {
    this.filtersChanged.emit();
  }

}
